// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLoading_root__1i5zs"};